import { css } from '@emotion/react'
import { Tooltip } from 'bold-ui'
import { ClassificacaoRiscoEncaminhamentoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import { classificacaoRiscoRecord } from '../model-encaminhamentoExterno'

interface StatusClassificacaoRiscoEncaminhamentoProps {
  status: ClassificacaoRiscoEncaminhamentoEnum
  size?: number
  showTooltip?: boolean
}

export function StatusClassificacaoRiscoEncaminhamento(props: Readonly<StatusClassificacaoRiscoEncaminhamentoProps>) {
  const { status, size = 1, showTooltip = true } = props

  const { mainColor, label } = classificacaoRiscoRecord[status]

  const classes = useMemo(() => createStyles(mainColor, size), [mainColor, size])

  return (
    <Tooltip text={showTooltip && label}>
      <div css={classes.classificacaoRiscoBox} />
    </Tooltip>
  )
}

const createStyles = (cor: string, size: number) => ({
  classificacaoRiscoBox: css`
    width: ${size}rem;
    height: ${size}rem;
    border-radius: 2px;
    background-color: ${cor};
  `,
})
